// extracted by mini-css-extract-plugin
module.exports = {"root":"FieldCheckboxGroup_root__3xCiy","list":"FieldCheckboxGroup_list__2tjic","twoColumns":"FieldCheckboxGroup_twoColumns__3ARpQ","item":"FieldCheckboxGroup_item__3IeP5"};